var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 795.72 657.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4174",
    "data-name": "Group 4174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3_Manufacturing_Units",
    "data-name": " 3 Manufacturing Units",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-470.34,4704.76h6.28c3.94-.06,7.05-1.1,9.3-3.11a10.43,10.43,0,0,0,3.39-8.18q0-11.56-11.52-11.56a12,12,0,0,0-8.65,3.09,10.84,10.84,0,0,0-3.23,8.2h-8.35a16.78,16.78,0,0,1,5.71-13q5.71-5.18,14.52-5.17,9.31,0,14.59,4.92t5.29,13.69a14.45,14.45,0,0,1-2.78,8.31,16.77,16.77,0,0,1-7.57,6,16.1,16.1,0,0,1,8.38,5.69,15.76,15.76,0,0,1,3,9.71q0,8.85-5.78,14.05t-15,5.19q-9.27,0-15.07-5a16.62,16.62,0,0,1-5.8-13.23h8.4a10.75,10.75,0,0,0,3.39,8.31,12.91,12.91,0,0,0,9.08,3.11q6,0,9.26-3.16t3.2-9.08q0-5.73-3.52-8.81t-10.16-3.16h-6.28Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-375.77,4675.94l21.5,53.67,21.5-53.67h11.25v65.77h-8.68V4716.1l.82-27.64L-351,4741.71h-6.64l-21.55-53.12.86,27.51v25.61H-387v-65.77Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-268.1,4741.71a17.58,17.58,0,0,1-1.17-5.15,18.63,18.63,0,0,1-13.91,6,17.28,17.28,0,0,1-11.86-4.08,13.22,13.22,0,0,1-4.63-10.37,13.82,13.82,0,0,1,5.8-11.86q5.81-4.22,16.33-4.22h8.13v-3.84a9.37,9.37,0,0,0-2.62-7c-1.74-1.73-4.32-2.6-7.72-2.6a12.23,12.23,0,0,0-7.5,2.26,6.65,6.65,0,0,0-3,5.47h-8.41a11.54,11.54,0,0,1,2.6-7.07,17.78,17.78,0,0,1,7.05-5.4,23.75,23.75,0,0,1,9.78-2q8.44,0,13.23,4.23t5,11.63v22.49a27.4,27.4,0,0,0,1.72,10.71v.72Zm-13.86-6.37a14.73,14.73,0,0,0,7.45-2,12.28,12.28,0,0,0,5.1-5.29v-10H-276q-15.35,0-15.35,9a7.6,7.6,0,0,0,2.62,6.14A10.08,10.08,0,0,0-282,4735.34Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-230.8,4692.84l.28,6.14a17.8,17.8,0,0,1,14.63-7q15.49,0,15.63,17.48v32.3h-8.36v-32.34q0-5.28-2.41-7.82c-1.58-1.68-4.05-2.52-7.39-2.52a12.11,12.11,0,0,0-7.14,2.16,14.83,14.83,0,0,0-4.78,5.69v34.83h-8.36v-48.87Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-148.23,4736.88q-4.89,5.73-14.32,5.73-7.81,0-11.91-4.53t-4.13-13.44v-31.8h8.36v31.57q0,11.11,9,11.11,9.58,0,12.74-7.13v-35.55h8.36v48.87h-8Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-114,4741.71V4699.3h-7.72v-6.46H-114v-5q0-7.86,4.2-12.15t11.88-4.29a22.46,22.46,0,0,1,5.74.76l-.45,6.74a24.19,24.19,0,0,0-4.52-.41,8.19,8.19,0,0,0-6.28,2.38c-1.48,1.59-2.21,3.86-2.21,6.82v5.17h10.43v6.46h-10.43v42.41Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-46.62,4741.71a17.58,17.58,0,0,1-1.17-5.15,18.65,18.65,0,0,1-13.92,6,17.26,17.26,0,0,1-11.85-4.08,13.22,13.22,0,0,1-4.63-10.37,13.82,13.82,0,0,1,5.8-11.86q5.81-4.22,16.33-4.22h8.13v-3.84a9.37,9.37,0,0,0-2.62-7q-2.62-2.6-7.72-2.6a12.23,12.23,0,0,0-7.5,2.26,6.66,6.66,0,0,0-3,5.47h-8.4a11.54,11.54,0,0,1,2.6-7.07,17.82,17.82,0,0,1,7-5.4,23.81,23.81,0,0,1,9.78-2q8.45,0,13.24,4.23t5,11.63v22.49A27.61,27.61,0,0,0-37.86,4741v.72Zm-13.87-6.37a14.76,14.76,0,0,0,7.46-2,12.34,12.34,0,0,0,5.1-5.29v-10h-6.55q-15.36,0-15.36,9a7.63,7.63,0,0,0,2.62,6.14A10.1,10.1,0,0,0-60.49,4735.34Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.38,4735.79a12,12,0,0,0,7.81-2.71,9.51,9.51,0,0,0,3.71-6.77h7.9a15.11,15.11,0,0,1-2.89,8,19.07,19.07,0,0,1-7.11,6.06,20.62,20.62,0,0,1-9.42,2.25q-10,0-15.88-6.66t-5.89-18.22v-1.4a29.42,29.42,0,0,1,2.62-12.7A19.85,19.85,0,0,1-9.25,4695a21.35,21.35,0,0,1,11.58-3.08A19.62,19.62,0,0,1,16,4696.86a17.57,17.57,0,0,1,5.8,12.78H13.9a11.52,11.52,0,0,0-3.59-7.79,11.2,11.2,0,0,0-8-3.05,11.69,11.69,0,0,0-9.86,4.58Q-11,4708-11,4716.64v1.58q0,8.45,3.48,13T2.38,4735.79Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.79,4681v11.84h9.12v6.46H51.79v30.34a6.75,6.75,0,0,0,1.22,4.41c.81,1,2.19,1.47,4.15,1.47a20.32,20.32,0,0,0,4-.54v6.74a24.33,24.33,0,0,1-6.42.89c-3.73,0-6.55-1.12-8.44-3.38s-2.85-5.47-2.85-9.62V4699.3h-8.9v-6.46h8.9V4681Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.09,4736.88q-4.87,5.73-14.32,5.73-7.81,0-11.9-4.53t-4.13-13.44v-31.8h8.35v31.57q0,11.11,9,11.11,9.57,0,12.74-7.13v-35.55h8.35v48.87h-8Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.79,4700.33a26.41,26.41,0,0,0-4.11-.31q-8.22,0-11.16,7v34.69h-8.35v-48.87h8.13l.13,5.64a13,13,0,0,1,11.66-6.55,8.39,8.39,0,0,1,3.7.64Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.76,4679.87a5,5,0,0,1,1.25-3.43,4.66,4.66,0,0,1,3.68-1.4,4.74,4.74,0,0,1,3.7,1.4,5,5,0,0,1,1.27,3.43,4.54,4.54,0,0,1-5,4.75,4.71,4.71,0,0,1-3.68-1.36A4.81,4.81,0,0,1,180.76,4679.87Zm9,61.84h-8.36v-48.87h8.36Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.32,4692.84l.28,6.14a17.8,17.8,0,0,1,14.63-7q15.5,0,15.63,17.48v32.3H242.5v-32.34q0-5.28-2.41-7.82T232.7,4699a12.11,12.11,0,0,0-7.14,2.16,14.83,14.83,0,0,0-4.78,5.69v34.83h-8.36v-48.87Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.72,4716.87q0-11.43,5.29-18.18a16.91,16.91,0,0,1,14-6.76q8.94,0,14,6.33l.41-5.42H312v47.7q0,9.48-5.62,14.95T291.28,4761a25.1,25.1,0,0,1-10.35-2.26,17.77,17.77,0,0,1-7.72-6.18l4.33-5q5.38,6.65,13.15,6.64,6.09,0,9.51-3.43t3.41-9.67v-4.2q-5,5.79-13.69,5.78A16.69,16.69,0,0,1,276,4735.7Q270.72,4728.8,270.72,4716.87Zm8.41.95q0,8.27,3.38,13a11,11,0,0,0,9.49,4.72q7.9,0,11.61-7.18V4706q-3.84-7-11.52-7a11.1,11.1,0,0,0-9.53,4.74Q279.13,4708.51,279.13,4717.82Z",
    transform: "translate(483.71 -4216.11)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-139,4807v44.72q0,9.31-5.85,15.22t-15.74,6.65l-2.31.09q-10.8,0-17.21-5.83t-6.5-16V4807H-178v44.54q0,7.14,3.93,11.09t11.2,3.95q7.36,0,11.27-3.93t3.91-11.06V4807Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-109.49,4823.89l.27,6.14A17.8,17.8,0,0,1-94.59,4823q15.5,0,15.63,17.48v32.3h-8.35v-32.34c0-3.52-.84-6.13-2.42-7.81s-4-2.53-7.38-2.53a12.11,12.11,0,0,0-7.14,2.16,14.72,14.72,0,0,0-4.79,5.7v34.82h-8.36v-48.87Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-57.06,4810.92a5,5,0,0,1,1.24-3.43,4.69,4.69,0,0,1,3.69-1.4,4.74,4.74,0,0,1,3.7,1.4,4.94,4.94,0,0,1,1.26,3.43,4.77,4.77,0,0,1-1.26,3.39,4.8,4.8,0,0,1-3.7,1.36,4.74,4.74,0,0,1-3.69-1.36A4.85,4.85,0,0,1-57.06,4810.92Zm9,61.84h-8.36v-48.87H-48Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-14.07,4812.05v11.84h9.13v6.46h-9.13v30.34a6.8,6.8,0,0,0,1.22,4.41c.82,1,2.2,1.47,4.16,1.47a20.24,20.24,0,0,0,4-.54v6.74a24.22,24.22,0,0,1-6.41.9q-5.59,0-8.45-3.39t-2.84-9.62v-30.31h-8.9v-6.46h8.9v-11.84Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.52,4859.8a6.15,6.15,0,0,0-2.55-5.26q-2.55-1.87-8.9-3.23A42,42,0,0,1,21,4848.05a14.37,14.37,0,0,1-5.51-4.51,10.83,10.83,0,0,1-1.79-6.24,12.68,12.68,0,0,1,5.09-10.16q5.07-4.16,13-4.16,8.31,0,13.49,4.3a13.65,13.65,0,0,1,5.17,11H42a7.57,7.57,0,0,0-2.92-5.92,10.94,10.94,0,0,0-7.34-2.48,11.36,11.36,0,0,0-7.13,2,6.23,6.23,0,0,0-2.58,5.19,5.06,5.06,0,0,0,2.4,4.56q2.38,1.55,8.64,2.94a45.09,45.09,0,0,1,10.15,3.34,14.9,14.9,0,0,1,5.75,4.68,11.48,11.48,0,0,1,1.88,6.66,12.5,12.5,0,0,1-5.24,10.5q-5.23,4-13.6,4a24.74,24.74,0,0,1-10.39-2.08,16.87,16.87,0,0,1-7.06-5.81,13.92,13.92,0,0,1-2.56-8.06h8.36a8.65,8.65,0,0,0,3.36,6.66,13.08,13.08,0,0,0,8.29,2.46,13.37,13.37,0,0,0,7.61-1.92A5.86,5.86,0,0,0,42.52,4859.8Z",
    transform: "translate(483.71 -4216.11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "industry"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2687",
    "data-name": "Group 2687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    className: "cls-2",
    d: "M-67.88,4309.25l-1.64,21.42h36.23L-35,4309.25Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    className: "cls-2",
    d: "M-215.88,4456.43a69.6,69.6,0,0,1,69.6-69.6,69.62,69.62,0,0,1,47.17,18.42l1.54-20.2-.77.4-2.55-1.6A84.64,84.64,0,0,0-127,4373l-2.31-.54-4-7.06h-25.87l-4,7.07-2.31.53a84.91,84.91,0,0,0-26.13,10.85l-2.55,1.6-11.61-5.8-17.26,17.25,5.81,11.61-1.6,2.55a84.8,84.8,0,0,0-10.84,26.14l-.68,2.93-12.28,4.08v24.41l12.28,4.09.68,2.94a84.89,84.89,0,0,0,10.84,26.13l1.6,2.55-5.81,11.57,17.26,17.26,11.61-5.81,2.55,1.6c1.81,1.13,8,4.72,13.24,7.71v-18.58a69.57,69.57,0,0,1-37.48-61.73Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    className: "cls-2",
    d: "M30.18,4467.39H82.94L75.29,4360.3H37.83Zm21-96.36h10.7v10.7H51.2Zm0,21.41h10.7v10.71H51.2Zm0,21.42h10.7v10.7H51.2Zm0,21.41h10.7V4446H51.2Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    className: "cls-2",
    d: "M40.13,4320.89l-1.54,21.42H74.51L73,4320.89Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    className: "cls-2",
    d: "M-76,4421.37h49.43l-5.8-75H-70.27Zm19.37-64.25H-46v10.71h-10.7Zm0,21.41H-46v10.71h-10.7Zm0,21.42H-46v10.71h-10.7Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    className: "cls-2",
    d: "M-68,4531.39h21.41v32.12H-68Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    className: "cls-2",
    d: "M-17.72,4477.84v-32.12H-156.93v117.79h53.54V4502.4l24.55-24.55Zm-117.79,75h-10.71v-10.72h10.71Zm0-21.41h-10.71v-10.71h10.71Zm0-21.42h-10.71v-10.71h10.71Zm0-21.41h-10.71v-10.72h10.71Zm0-21.42h-10.71v-10.71h10.71Zm21.41,85.67h-10.71v-10.73h10.71Zm0-21.41h-10.71v-10.72h10.71Zm0-21.42h-10.71v-10.72h10.71Zm0-21.42h-10.71v-10.72h10.71Zm0-21.41h-10.71v-10.72h10.71Zm75-10.71h10.71v10.71H-39.14Zm-21.41,0h10.71v10.71H-60.57Zm-32.12,10.71h-10.72v-10.72h10.71Zm10.7-10.71h10.71v10.71H-82Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    className: "cls-2",
    d: "M-9.81,4531.39H11.6v32.12H-9.81Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    className: "cls-2",
    d: "M-69.73,4493.85H94v-10.71H-59Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    className: "cls-2",
    d: "M-77.3,4563.52h10.7v-42.84h42.84v42.83h10.7v-42.83H29.77v42.83H40.49v-42.83H83.32v42.83H94V4510H-77.3Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    className: "cls-2",
    d: "M51.21,4531.39H72.62v32.12H51.21Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    className: "cls-2",
    d: "M88.69,4248.24H40.5v10.7H88.69a5.36,5.36,0,0,1,0,10.71H78a16.09,16.09,0,0,0-16.07,16.07v5.36H72.62v-5.36a5.4,5.4,0,0,1,5.36-5.36H88.69a16.06,16.06,0,0,0,0-32.12Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    className: "cls-2",
    d: "M10.88,4280.37H21.59a5.41,5.41,0,0,1,5.36,5.36v5.35h10.7v-5.36a16.08,16.08,0,0,0-16.06-16.07H10.88a16.06,16.06,0,0,1-.7-32.12H48.36v-10.71H10.88a26.78,26.78,0,1,0,0,53.55Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    className: "cls-2",
    d: "M72.62,4226.82H83.33v10.71H72.62Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    className: "cls-2",
    d: "M-210.52,4248.24H-173a5.39,5.39,0,0,1,5.36,5.35,16.08,16.08,0,0,0,16.06,16.07h64.26A5.39,5.39,0,0,1-82,4275v5.36H-71.3V4275a16.08,16.08,0,0,0-16.06-16.07h-64.27a5.38,5.38,0,0,1-5.35-5.35A16.09,16.09,0,0,0-173,4237.52h-37.47a5.36,5.36,0,0,1-5.56-5.15,5.36,5.36,0,0,1,5.15-5.56h59.3v-10.7h-58.89a16.08,16.08,0,0,0-16.42,15.71,16.08,16.08,0,0,0,15.71,16.42Z",
    transform: "translate(483.71 -4216.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    className: "cls-2",
    d: "M-90.37,4248.24H-74.3A26.8,26.8,0,0,1-47.54,4275v5.36h10.71V4275a37.52,37.52,0,0,0-37.48-37.48H-90.37a5.36,5.36,0,0,1-5.56-5.15,5.36,5.36,0,0,1,5.15-5.56h59.31v-10.71h-58.9a16.06,16.06,0,0,0-16.41,15.71,16.07,16.07,0,0,0,15.71,16.42Z",
    transform: "translate(483.71 -4216.11)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5);
export default __webpack_public_path__ + "static/media/img-5.bd660a3475878c2be4f60f669533cdd9.svg";
export { ForwardRef as ReactComponent };